import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  filterContainer: {
    display: 'flex',
    gap: 'clamp(12px, 1.56vw, 32px)',
  },
  selectStatus: {
    width: 'clamp(114px, 14.90vw, 305px)',
  },
  searchField: {
    width: 'clamp(114px, 14.90vw, 305px)',
    '& .MuiOutlinedInput-root': {
    },
    '& .MuiInputBase-input': {
      color: theme.palette.text.primary,
    },
    '& .MuiOutlinedInput-input': {
      paddingTop: '10px',
      paddingBottom: '10px',
    },
    '& .MuiInputAdornment-root .MuiSvgIcon-root': {
      color: theme.palette.text.primary,
    },
  },
  title: {
    fontSize: '24px',
    fontWeight: 700,
    color: theme.palette.primary.main,
    gap: '8px',
    display: 'flex',
    alignItems: 'center',
  },
}));

export default useStyles;
